
import Vue from "vue";
import { IBillingInfo, IStateProvince } from "../types";
import { STATE_PROVINCE } from "../constants/StateProvince";
import fieldEntryMixin from "@/components/mixins/fieldEntryMixin.vue";
import store from "../store";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "billing-info",
  mixins: [fieldEntryMixin],
  data: function() {
    return {
      states: STATE_PROVINCE as IStateProvince[],
      selectedState: {
        code: "PA",
        countryCode: "US",
        name: "Pennsylvania"
      } as IStateProvince,
      selectedCountryCode: "US" as string
    };
  },
  props: {
    isReadonly: { type: Boolean, default: false },
    nameLabel: { type: String },
    requireEmail: { type: Boolean, default: false }
  },
  computed: {
    nameLabelFull(): string {
      return this.nameLabel+' *';
    },
    paddingClass(): string {
      return this.isReadonly ? "pt-0 pb-0 pl-0 pr-2" : "pa-1";
    },
    billingInfo(): any {
      //@ts-ignore
      return store.getters.billingModule.getBilling;
    },
    phoneNumber: {
      get(): string {
        return this.billingInfo.phone;
      },
      set(newPhone: string) {
        this.billingInfo.phone = newPhone;
      }
    }
  },
  watch: {
    selectedState(val: IStateProvince) {
      this.selectedCountryCode = val.countryCode;
      this.billingInfo.state = val.code;
    }
  },
  methods: {
    emailVerifyRequired(value: string): any {
      let returnValue: any = true;
      if (
        this.billingInfo.email &&
        this.billingInfo.email.length > 0 &&
        value.length < 1
      ) {
        returnValue = "Verify Email Required.";
      }
      return returnValue;
    },
    emailVerifyMatch(value: string): any {
      let returnValue: any = true;
      if (this.billingInfo.email) {
        if (
          this.billingInfo.email.toLowerCase() !==
          this.billingInfo.emailVerify.toLowerCase()
        ) {
          returnValue = "Email Adresses Must Match.";
        }
      }
      return returnValue;
    },
    stateFilter(item: IStateProvince, queryText: string, itemText: string) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.code.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    saveBillingToStore() {
      //@ts-ignore
      store.commit.billingModule.SET_BILLING(this.billingInfo);
    }
  }
});
